import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM15.7898 6.52269C15.4054 6.13827 14.7821 6.13827 14.3977 6.52269C14.3884 6.53198 14.3797 6.54181 14.3716 6.55214L9.81408 12.3595L7.06634 9.61173C6.68192 9.22731 6.05864 9.22731 5.67422 9.61173C5.2898 9.99615 5.2898 10.6194 5.67422 11.0038L9.14768 14.4773C9.53211 14.8617 10.1554 14.8617 10.5398 14.4773C10.5484 14.4687 10.5564 14.4597 10.564 14.4503L15.8038 7.90056C16.1742 7.51513 16.1695 6.9024 15.7898 6.52269Z",
            fill: "white"
        })
    });
};
export default Icon;
